export enum TreatmentType {
  NightGuard = 1,
  SmileDesign = 2,
  BracketRemoval = 3,
  SurgicalGuide = 4,
  RemovablePartialDenture = 5,
  ClearAligner = 6,
  SingleImplantWithCrown = 7,
  CrownAndBridge = 8,
  CustomBleachingTray = 9,
  RemovableDentures = 10,
  AINightGuard = 11,
  HybridDentures = 13,
  AICrown = 14,
  SmileCorrect = 15,
  Veneers = 16,
  AICrownWithCAD = 17,
  AIRetainer = 18,
  DentalModel = 19,
  ImplantRestorations = 20,
  ManualRetainer = 21,
  Moment = 32,
  NeerCrystal = 37,
  Custom = 100,
  NotSelected = 101,
}
